import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SideNavLayout from "../customsidenav/sidenavlayout";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useRef, useState } from "react";
import calendericon from '../assets/auth/calendericon.svg';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SigninTable from "./signintable";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Backdrop, CircularProgress, styled, Typography } from "@mui/material";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DateRangeSelector from "../daterangepicker/DateRangeSelector";
import "bootstrap/dist/css/bootstrap.min.css";
import api from '../api/api'
import { formatDateToYYYYMMDD } from "../dateutils/date";
import FilterPopup from "./popups/filterpopup";
import Filtericon from '../../src/assets/patientcharts/mdi_filter-outline (1).svg'
import { dateiconbig } from "../utils/svgs/svgcode";
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
    '& .MuiPickersCalendarHeader-label': {
      fontSize: '15px', // Adjust the size as needed
    },
}));

// SigninTab component
const SigninTab = () => {
       const practiseid= window.getPracticeId()
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [selectedDate, setSelectedDate] = React.useState(dayjs());
    const currentDate = new Date().toISOString().split('T')[0];
    const [isFilterPopup,SetIsFilterPopup]=useState(false)
    const [searchTerm, setSearchTerm] = useState('');
     const[providersdata,setProvidersData]=useState([])
     const [selectedStatus,setSelectedStatus]=useState(null)
     const [selectedProvider,setSelectedProvider]=useState([]);
     const [showCheckedOut, setShowCheckedOut] = useState(false);
  const showdate=useRef()


  const calendarPopupRef = useRef(null);  // Step 1: Create the ref

  const[data,setData]=useState([])
   const [filterData,setFilterData]=useState([])
   const [checked, setChecked] = useState({
    all: true,
    ShowMR: false,
    ShowCancelled: false,
    ShowChecked: false,
    ShowAll: false,
    
  });

  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
});
    const [isChecked, setIsChecked] = useState(false);
    const filterDateRef = useRef(currentDate);
    const [loading,setLoading]=useState(false);
     const dateRangeRef = useRef(selectedDateRange);
    const handleDateChange = (prop) => {
       setSelectedDate(prop)
       setIsCalendarOpen(false);   
    };
    const handledateSelect=()=>{
  
     fetchdata({dt:selectedDateRange})
       setIsCalendarOpen(false)
    }
    const handlereset=()=>{
  
     fetchdata({dt:{
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
}})
       setIsCalendarOpen(false)
    }

    // 12241
    const fetchdata = async ({dt='',load=true}) => {
      // Use `a` if provided, otherwise fallback to `selectedDateRange`
    
      const dateRange = dt || selectedDateRange;
    
      // Format startDate and endDate using dayjs to ensure consistency
      const formattedStartDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
      const formattedEndDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");
      showdate.current=dayjs(dateRange.startDate).format("YYYY-MM-DD")
      try {
        if(load){
            setLoading(true);
        }
      
        let response = await api.post(`/v1/${practiseid}/checkin/future/get`, {
          stdate: formattedStartDate,
          eddate: formattedEndDate,
        });
    
        if (response.status === 200) {
          setData(response.data);
        } else {
          setData([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
 
    
    useEffect(()=>{
        document.title = "CHIM - Sign-in";
        fetchdata({})
    },[])
    useEffect(()=>{
        fetchdata({})
    },[selectedDate])

    const handleStatusSelect = (status) => {
      console.log("Selected status:", status);
      setSelectedStatus(status); // Set the selected status
   
    };

    const handleSelectedProvider=(provider)=>{
      setSelectedProvider(provider)
    }
     useEffect(() => {
  dateRangeRef.current = selectedDateRange;
}, [selectedDateRange]);
  useEffect(() => {
  console.log("🔄 useEffect triggered with dependencies:");
  console.log({ searchTerm, selectedStatus, selectedProvider, dataLength: data.length, showCheckedOut, checked });

  let filteredData = [...data];
  console.log("Step 1️⃣ Original data length:", filteredData.length);

  if (!showCheckedOut) {
    filteredData = filteredData.filter(item =>
      ["Ready for Triage", "Processing", "Ready for Checkout", "Ready for Provider","Walk-in",
    "Speak with Nurse",
    "Labs/Injections",
    "Speak with Representative",
    "Tele - Confirmed"].includes(item.visit_confirmation)
    );
    console.log("Step 2️⃣ After removing checked out patients:", filteredData.length);
  }

  if (selectedStatus) {
    filteredData = filteredData.filter(item => item.visit_confirmation === selectedStatus);
    console.log(`Step 3️⃣ After filtering by selectedStatus (${selectedStatus}):`, filteredData.length);
  }

  if (Array.isArray(selectedProvider) && selectedProvider.length > 0) {
    filteredData = filteredData.filter(item => selectedProvider.includes(item.linked_provider));
    console.log(`Step 4️⃣ After filtering by selectedProvider:`, filteredData.length);
  }

  if (checked.ShowAll) {
    console.log("✅ ShowAll is true — full dataset used");
    // No further filtering, but still apply searchTerm filter below
  } else if (checked.ShowMR) {
    console.log("✅ ShowMR is true — filtering for MR items");
    filteredData = filteredData.filter(item => item.visit_confirmation === "MR");
    console.log("Step 5️⃣ After filtering for ShowMR:", filteredData.length);
  } else {
   
    const applyCancelled = checked.ShowCancelled;
    const applyCheckedOut = checked.ShowChecked;

    if (applyCancelled || applyCheckedOut) {
      filteredData = filteredData.filter(item => {
        const status = item.visit_confirmation;

        return (
          (applyCancelled && status === "Cancelled") ||
          (applyCheckedOut && status === "Checked Out")
        );
      });
      console.log("✅ Applied filter for Cancelled/Checked Out:", filteredData.length);
    } else {
      console.log("ℹ️ Both ShowCancelled and ShowChecked are false — no filtering applied");
    }
  }

  const searchLower = searchTerm.toLowerCase();
  filteredData = filteredData.filter(item => {
    const fullName = `${item.firstname} ${item.lastname}`.toLowerCase();
    const idString = String(item.patientid).toLowerCase();
    return fullName.includes(searchLower) || idString.includes(searchLower);
  });
  console.log("Step 6️⃣ After applying search filter:", filteredData.length);

  setFilterData(filteredData);
}, [searchTerm, selectedStatus, selectedProvider, data, showCheckedOut, checked]);
 useEffect(()=>{
    console.log(selectedProvider,"provider",selectedStatus,'status',checked,'checked')
  },[selectedProvider,selectedStatus,checked])
  
    
  const toggleShowCheckedOut = () => {
    setShowCheckedOut(prevState => !prevState);
   };
    
   
    const clearFilters = () => {
      setSelectedStatus(null); // Reset status filter
      setSelectedProvider([]); // Reset provider filter
      setSearchTerm(''); // Clear search term
      setFilterData(data); // Reset filterData to full data
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (calendarPopupRef.current && !calendarPopupRef.current.contains(event.target)) {
          setIsCalendarOpen(false);  // Step 2: Close the calendar if clicked outside
        }
      };
      document.addEventListener("mousedown", handleClickOutside);  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
      }, []);
      const mergeUpdatedRows = (serverData) => {
  setData((prev) => {
    const map = new Map(prev.map((row) => [row.appointmentid, row]));

    serverData.forEach((serverRow) => {
      const existing = map.get(serverRow.appointmentid);

      if (!existing) {
        // new row
        map.set(serverRow.appointmentid, serverRow);
      } else {
        // update only if changed
        if (JSON.stringify(existing) !== JSON.stringify(serverRow)) {
          map.set(serverRow.appointmentid, {
            ...existing,
            ...serverRow,
          });
        }
      }
    });

    return Array.from(map.values());
  });
};

 const backgroundFetch = async () => {
  try {
    const range = dateRangeRef.current;

    const formattedStartDate = dayjs(range.startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(range.endDate).format("YYYY-MM-DD");

    const response = await api.post(`/v1/${practiseid}/checkin/future/get`, {
      stdate: formattedStartDate,
      eddate: formattedEndDate,
    });

    if (response.status === 200) {
      mergeUpdatedRows(response.data);
    }
  } catch (e) {
    console.log(e);
  }
};


      useEffect(() => {
  const interval = setInterval(() => {
    backgroundFetch();
  }, 2000);

  return () => clearInterval(interval);
}, []);

    
    return (
        <>
            <div className="h-full">
                <SideNavLayout>
                    <div className="w-full flex justify-between">
                    <div className="flex gap-4 items-center">
                        <div
                            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                            className="flex items-center justify-between gap-2 px-4 py-2 rounded-[20px] bg-[#fff]  cursor-pointer"
                        >
                     <div className="text-sm flex flex-col items-start">
  {(() => {
const today = dayjs(); // Use dayjs throughout

const startDateObj = selectedDateRange?.startDate
  ? dayjs(selectedDateRange.startDate)
  : today;

const endDateObj = selectedDateRange?.endDate
  ? dayjs(selectedDateRange.endDate)
  : today;

const isToday = startDateObj.isSame(today, 'day');

// Format: MM.DD.YYYY
const formatDate = (date) => date.format("MM.DD.YYYY");

const formattedStartDate = formatDate(startDateObj);
const formattedEndDate = formatDate(endDateObj);


    return (
      <div className="flex items-end gap-2">
        <div className="flex items-start flex-col">
          {isToday && (
            <div className="text-[#1D2951] font-semibold text-[9px]">Today</div>
          )}
          <span>
            {formattedStartDate === formattedEndDate
              ? formattedStartDate
              : `${formattedStartDate} - ${formattedEndDate}`}
          </span>
        </div>
        <div>{dateiconbig}</div>
      </div>
    );
  })()}
</div>

                          
                          
                        </div>
                        <img style={{width:'28px',cursor:"pointer"}}  onClick={()=>{SetIsFilterPopup(!isFilterPopup)}} src={Filtericon} alt="$/"/>
                        <div className="flex items-center space-x-2 mt-2">
      <label className="inline-flex items-center cursor-pointer">
    <input
  type="checkbox"
  className="sr-only peer focus:outline-none focus:ring-0"
  checked={showCheckedOut}
  onChange={toggleShowCheckedOut}
/>

        <div className="relative w-9 h-5 bg-gray-200 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#E17954] dark:peer-checked:bg-[#E17954]"></div>
        <span className="ms-3 text-sm font-medium text-[#000000] dark:text-gray-300">View All Appointments</span>
      </label>
    </div>
                        {/* <FilterAltIcon/> */}
                    </div>
                         <div className="flex-1 min-w-[250px] max-w-[388px] relative">
              <div className="relative flex items-center bg-gray-100 border sm:min-w-[350px] border-gray-300 rounded-full py-2 pl-2 pr-4">
                                {/* Left-aligned search icon inside the input field */}
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="text-gray-400 ml-3"
                                />
                                {/* Search input field with reduced height */}
                                <input
  type="text"
   className="w-full text-sm bg-transparent border-none outline-none pl-2 text-neutral-700"
  placeholder="Search for patients"
  value={searchTerm} // Bind value to searchTerm
  onChange={(e) => setSearchTerm(e.target.value)} // Update searchTerm on input change
/>

                            </div>
                        </div>
                    </div>

                <div className="flex flex-wrap items-center gap-2  p-2 rounded-md">
        {selectedDateRange.startDate && !dayjs(selectedDateRange.startDate).isSame(dayjs(), 'day') && (
    <div className="flex items-center bg-indigo-500 text-white px-3 py-1 rounded-full text-sm">
      {`${dayjs(selectedDateRange.startDate).format('MM-DD-YYYY')} - ${dayjs(selectedDateRange.endDate).format('MM-DD-YYYY')}`}
      <button
        onClick={() => setSelectedDateRange({
          startDate: new Date(),
          endDate: new Date(),
          key: 'selection'
        })}
        className="ml-2 focus:outline-none"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  )}
      {/* Provider Chips */}
      {selectedProvider.map((providername, index) => (
        <div
        onClick={()=>{
             setSelectedProvider((prevSelectedProviders) => {
      if (prevSelectedProviders.includes(providername)) {
        // Deselect the provider if it's already selected
        return prevSelectedProviders.filter((provider) => provider !== providername);
      } else {
        // Add the provider to the selected array
        return [...prevSelectedProviders, providername];
      }
    });
        }}
          key={index}
          className="flex items-center bg-blue-500 text-white px-3 py-1 rounded-full text-sm"
        >
          {providername}
          <button
            // onClick={() => removeProvider(provider)}
            className="ml-2 focus:outline-none"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      ))}

      {/* Status Chip */}
      {selectedStatus && (
        <div className="flex items-center bg-green-500 text-white px-3 py-1 rounded-full text-sm">
          {selectedStatus}
          <button
            onClick={()=>{  setSelectedStatus(null); }}
            
            className="ml-2 focus:outline-none"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      )}
        {checked && Object.keys(checked).map((key) => (
    checked[key]&&key!=='all' && (
      <div
        key={`checked-${key}`}
        onClick={() => {
          setChecked((prev) => ({
            ...prev,
            [key]: false,
          }));
      
        }}
        className="flex items-center bg-gray-500 text-white px-3 py-1 rounded-full text-sm"
      >
        {key}
        <button
          // onClick={() => removeCheckedKey(key)}
          className="ml-2 focus:outline-none"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    )
  ))}
  {(selectedProvider.length > 0 || selectedStatus ||selectedDateRange.startDate && !dayjs(selectedDateRange.startDate).isSame(dayjs(), 'day')||   Object.keys(checked).some((key) => checked[key] && key !== 'all')) && (
    <div
      className="flex items-center bg-red-500 text-white px-3 py-1 rounded-full text-sm cursor-pointer"
      onClick={() => {
        if (selectedDateRange.startDate && !dayjs(selectedDateRange.startDate).isSame(dayjs(), 'day')) {
  const today = dayjs();
  
  const newRange = {
    startDate: today.toDate(),
    endDate: today.toDate(),
    key: 'selection'
  };

  setSelectedDateRange(newRange);

  fetchdata({dt:newRange});
}
        
        
        setSelectedProvider([]);
        setSelectedStatus(null);
        setChecked((prev) => {
          const cleared = {};
          Object.keys(prev).forEach(key => {
            cleared[key] = false;
          });
          return cleared;
        });
        
      }}
    >
      Clear All <FontAwesomeIcon icon={faTimes} className="ml-2" />
    </div>
  )}
    </div>

                    <div className="w-full flex mt-4 justify-center ">
                        <SigninTable
                        fetchdata={fetchdata}
                        selectedDate={showdate.current}
                        loading={loading}
                        data={filterData}
                        providersdata={providersdata}
                        setProvidersData={setProvidersData}
                        onStatusSelect={handleStatusSelect} 
                        statusdata={data}
                        onProviderSelect={handleSelectedProvider}
                        isChecked={showCheckedOut}
                        setData={setData}
                        />
                    </div>
                </SideNavLayout>
            </div>

            {isCalendarOpen && (<>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="fixed top-[22%] left-20 z-50 w-[300px] bg-white  shadow-lg rounded-xl">
                        <CustomDateCalendar
                            value={selectedDate}
                            onChange={handleDateChange}
                        />
                    </div>
                </LocalizationProvider> */}
                <div  ref={calendarPopupRef}  className="fixed top-[10%] left-0 sm:top-[22%] sm:left-[10%] z-50 w-[300px] bg-white  shadow-lg rounded-xl">
                <DateRangeSelector
              onSubmit={handledateSelect}
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              handlereset={handlereset}
                     />
                </div>
                
                </>
                     
            )}
              <Backdrop
                       sx={{
                         color: 'secondary.main', // Sets the CircularProgress color to secondary
                         backgroundColor: 'rgba(255, 255, 255, 0.5)', // Semi-transparent white background
                         zIndex: (theme) => theme.zIndex.drawer + 1
                       }}
                       open={loading}
                     >
                       <CircularProgress color="secondary" />
                     </Backdrop>
                     <FilterPopup checked={checked}
                     parentselectedstatus={selectedStatus}
                     parentprovider={selectedProvider}
                     parentchecked={checked}
                     setChecked={setChecked}
                     isOpen={isFilterPopup}
                      onClose={()=>SetIsFilterPopup(false)}
                      data={data}
                      onStatusSelect={handleStatusSelect} 
                      onProviderFilter={handleSelectedProvider}
                      clearFilters={clearFilters}
                      />
                     
        </>
    );
};

export default SigninTab;
